import type { ReactElement, ReactNode } from 'react'
import { Divider } from '@mui/material'

export type DividerHeadingProps = {
  children: ReactNode
  /** Space above the rule, in theme units. Default: 1. */
  spacingTop?: number
}

/**
 * A centred caption sitting on a horizontal rule, styled like the wind load
 * parameter groups. Groups the fields of a form section without spending a full
 * heading row on the label.
 */
export const DividerHeading = ({ children, spacingTop = 1 }: DividerHeadingProps): ReactElement => (
  <Divider textAlign="center" sx={{ mt: spacingTop, mb: 1 }}>
    {children}
  </Divider>
)
